/**
 * Created by claudio iozzia on 28/06/2017.
 */
import {IAcceptor} from "../../../models/acceptor/IAcceptor";
import {Ic} from "../../../models/common";
import {Utils} from "../../../common/utils";
import {Acceptor_DcDc_Buck} from "./acceptor/dcdc_buck_acceptor";
import {
  TOPOLOGY_BOOST,
  TOPOLOGY_BUCK,
  TOPOLOGY_BUCK_BOOST,
  TOPOLOGY_INVERTING_BUCK_BOOST,
  TOPOLOGY_ISOLATED_BUCK,
  TOPOLOGY_ISOLATED_FLYBACK,
  TOPOLOGY_LLC,
  TOPOLOGY_POSITIVE_BUCK_BOOST
} from "../../../models/view";
import {Acceptor_DcDc_Viper} from "./acceptor/dcdc_viper_acceptor";
import {Acceptor_Common} from "../../../models/acceptor/acceptor_common";
import {IUpdateDesign, UpdateDesign} from "../../../models/IUpdateDesign";
import {UpdateDesign_DcDc_Buck, UpdateDesign_DcDc_BuckBoost} from "./update-design";
import {IComparator} from "../../../models/IComparator";
import {Comparator_DcDc} from "./comparator";
import {IValidator} from "../../../models/validator/IValidator";
import {Validator_Common} from "../../../models/validator/validator_common";
import {isNull} from "util";
import {Acceptor_DcDc_MultiBuck} from "./acceptor/dcdc_multiBuck_acceptor";
import {Acceptor_DcDc_Buck_6902} from "./acceptor/dcdc_buck_6902_acceptor";
import {Acceptor_DcDc_Boost} from "./acceptor/dcdc_boost_acceptor";
import {Acceptor_DcDc_InvertingBuckBoost} from "./acceptor/dcdc_invetingBuckBoost";
import {IAppFactoryService} from "../../../Redux/selector.state";
import {Feature} from "../../../models/features/features";
import {Validator_DcDc_Buck} from "./validator/dcdc_buck_validator";
import {Validator_DcDc_Buck_6902} from "./validator/dcdc_buck_6902_validator";
import {Validator_DcDc_Boost} from "./validator/dcdc_boost_validator";
import {Validator_DcDc_BuckBoost} from "./validator/dcdc_buck_boost_validator";
import {Validator_DcDc_InvertingBuckBoost} from "./validator/dcdc_inverting_buckboost_validator";
import {Validator_DcDc_MultiBuck} from "./validator/dcdc_multibuck_validator";
import {Validator_DcDc_798xPositiveBuckBoost} from "./validator/dcdc_positive_buckboost_798x_validator";
import {Validator_DcDc_Viper} from "./validator/dcdc_viper_validator";
import {Acceptor_DcDc_BuckBoost} from "./acceptor/dcdc_buck_boost_acceptor";
import {Acceptor_DcDc_798xBuckBoost} from "./acceptor/dcdc_buck_boost_798x_acceptor";
import {Acceptor_DcDc_LLC} from "./acceptor/dcdc_llc_acceptor";
import {Validator_DcDc_LLC} from "./validator/dcdc_llc_validator";
import {Validator_DcDc_IsolatedBuck} from "./validator/dcdc_isolated_buck_validator";


export class DcDc_Factory {

  private static createAcceptor(a: Ic): IAcceptor {
    // a:Ic cannot be never null
    if (Utils.getFieldValue(a, "validator.implementerClass", null) != null && Utils.getFieldValue(a, "validator.implementerClass", null) === 'pm') {
      return new Acceptor_DcDc_MultiBuck();
    } // injector.getInstance(Acp_onSpec_MultiBuck);
    if (a.partNumber.indexOf("6902") !== -1) {
      return new Acceptor_DcDc_Buck_6902();
    } else {
      // injector.getInstance(Acp_onSpec_Buck_6902);
      switch (a.topology.toLowerCase()) {
        case TOPOLOGY_ISOLATED_FLYBACK      :
          return new Acceptor_DcDc_Viper(); // injector.getInstance(Acp_onSpec_Viper);
        case TOPOLOGY_BOOST                 :
          return new Acceptor_DcDc_Boost(); // injector.getInstance(Acp_onSpec_Boost);
        case TOPOLOGY_BUCK_BOOST            :
          return new Acceptor_DcDc_BuckBoost(); // injector.getInstance(Acp_onSpec_BuckBoost);
        case TOPOLOGY_POSITIVE_BUCK_BOOST   :
          return new Acceptor_DcDc_798xBuckBoost(); // injector.getInstance(Acp_onSpec_798xBuckBoost);
        case TOPOLOGY_INVERTING_BUCK_BOOST  :
          return new Acceptor_DcDc_InvertingBuckBoost(); // injector.getInstance(Acp_onSpec_InvertingBuckBoost);
        case TOPOLOGY_BUCK                  :
          return new Acceptor_DcDc_Buck();
        case TOPOLOGY_LLC                   :
          return new Acceptor_DcDc_LLC();
        default                             :
          return new Acceptor_Common();
      }
    }
  }

  private static createUpdateDesign(a: Ic): IUpdateDesign {

    // TODO in MultiBuck no update verify is performed (PM66) to check
    if (a.partNumber.indexOf("PM66") !== -1 && Utils.getFieldValue(a, "validator.implementerClass", null) != null) {
      return new UpdateDesign();
    } // injector.getInstance(Acp_onSpec_MultiBuck);

    switch (a.topology.toLowerCase()) {
      case TOPOLOGY_ISOLATED_FLYBACK      :
        return new UpdateDesign();
      case TOPOLOGY_BOOST                 :
      case TOPOLOGY_BUCK_BOOST            :
      case TOPOLOGY_POSITIVE_BUCK_BOOST   :
      case TOPOLOGY_INVERTING_BUCK_BOOST  :
        return new UpdateDesign_DcDc_BuckBoost();
      case TOPOLOGY_BUCK                  :
        return new UpdateDesign_DcDc_Buck();
      default                             :
        return new UpdateDesign();
    }

  }

  private static createComparator(): IComparator {
    return new Comparator_DcDc();
  }

  private static createValidator(a: Ic): IValidator {
    if (isNull(a)) {
      return new Validator_Common();
    }
    if (Utils.getFieldValue(a, "validator.implementerClass", null) != null && Utils.getFieldValue(a, "validator.implementerClass", null) === 'pm') {
      // Attualmente (Marzo 2022) non gestiti; dispositivi introdotti con le seguenti release note
      // release_note 6.2.0: September 2012 : Added DC/DC converter -> DC/DC Buck -> PM6644
      // release_note 6.0.0: March 2012 : Added DC/DC multi-output controllers -> DC/DC Buck -> PM6680, PM6680A, PM6641, PM6670S, PM6670AS
      return new Validator_DcDc_MultiBuck();
    } else {
      switch (a.topology.toLowerCase()) {
        case TOPOLOGY_ISOLATED_BUCK:
          return new Validator_DcDc_IsolatedBuck();
        case TOPOLOGY_ISOLATED_FLYBACK:
          return new Validator_DcDc_Viper();
        case TOPOLOGY_BOOST:
          return new Validator_DcDc_Boost();
        case TOPOLOGY_BUCK_BOOST:
          return new Validator_DcDc_BuckBoost();
        case TOPOLOGY_POSITIVE_BUCK_BOOST:
          return new Validator_DcDc_798xPositiveBuckBoost();
        case TOPOLOGY_INVERTING_BUCK_BOOST:
          return new Validator_DcDc_InvertingBuckBoost();
        case TOPOLOGY_BUCK             :
          return a.partNumber.indexOf("6902") !== -1 ? new Validator_DcDc_Buck_6902() : new Validator_DcDc_Buck();
        case TOPOLOGY_LLC              :
          return new Validator_DcDc_LLC();
        default:
          return new Validator_Common();
      }
    }
  }

  private static createStdFeature(): Feature[] {
    return [
      {feature: {label: "Automotive Grade", level: 1001}}
      , {feature: {label: "Embedded Synchronous Rectifier", level: 1002}}
      , {feature: {label: "Controller", level: 1003}}
      , {feature: {label: "Selectable", category: "Sw.Frequency", level: 1004}}
      , {feature: {label: "Synch", category: "Pin", level: 1005}}
    ];
  }

  public static createService(): IAppFactoryService {
    return {
      acceptorCreator: DcDc_Factory.createAcceptor,
      updateDesignCreator: DcDc_Factory.createUpdateDesign,
      comparator: DcDc_Factory.createComparator(),
      validatorCreator: DcDc_Factory.createValidator,
      stdFeatures: DcDc_Factory.createStdFeature()
    };
  }

}
